import React from 'react';
import Icon from '.';

const ChevronThinRightIcon = props => (
	<Icon viewBox="0 0 24 24" {...props}>
		<defs>
			<path d="M4 18v-2h10V6h2v12H4z" id="ChevronThinRight_svg__a" />
		</defs>
		<g fill="currentColor" fillRule="evenodd">
			<mask id="ChevronThinRight_svg__b" fill="#fff">
				<use xlinkHref="#ChevronThinRight_svg__a" />
			</mask>
			<use transform="rotate(-45 10 12)" xlinkHref="#ChevronThinRight_svg__a" />
		</g>
	</Icon>
);

export default ChevronThinRightIcon;
